/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  fetchTransactions({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/cockpit/invoices")
        .then((response) => {
          commit('SET_TRANSACTIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchTransaction(context, identifier) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/admin/cockpit/invoices/by_identifier/${identifier}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  releaseFunds(context, identifier) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/admin/cockpit/invoices/release/funds/${identifier}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
